// Love Your List — Theme JS

document.addEventListener('DOMContentLoaded', function() {

  // Sticky header shadow on scroll
  const header = document.getElementById('site-header');
  window.addEventListener('scroll', function() {
    if (window.scrollY > 20) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  // Search toggle
  const searchToggle = document.querySelector('.search-toggle');
  const searchDrawer = document.getElementById('search-drawer');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function() {
      searchDrawer.classList.toggle('open');
      if (searchDrawer.classList.contains('open')) {
        searchDrawer.querySelector('input').focus();
      }
    });
  }

  // Mobile menu toggle
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      mobileNav.classList.toggle('open');
    });
  }

  // Add to cart feedback
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      const btn = document.getElementById('add-to-cart-btn');
      if (btn && !btn.disabled) {
        const original = btn.textContent;
        btn.textContent = 'Added ✓';
        btn.style.background = 'var(--sage)';
        setTimeout(function() {
          btn.textContent = original;
          btn.style.background = '';
        }, 2000);
      }
    });
  }

  // Lazy load images
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          imageObserver.unobserve(entry.target);
        }
      });
    });
    lazyImages.forEach(function(img) {
      imageObserver.observe(img);
    });
  }

});
